import React from "react";
import "../../Styles/yellocalfcss/SelectStudent.css";

function GenerateInvoice() {
  return (
    <div className="SelectStudent-container my-4">
      <div className="SelectStudent-invoice-header">
        <h4>Generate Invoice</h4>
      </div>

      <div className="SelectStudent-invoice-form">
        <div className="SelectStudent-form-group">
            <label>Select Category</label>
            <select>
              <option>Select</option>
              <option>Medical Expenses</option>
              <option>Hostel Fees</option>
              <option>Busfare</option>
            </select>
          </div>

        <div className="SelectStudent-form-row">
          <div className="SelectStudent-form-group">
            <label>Select Grade</label>
            <select>
              <option>Select Grade</option>
            </select>
          </div>

          <div className="SelectStudent-form-group">
            <label>Select Academic Year</label>
            <select>
              <option>Academic Year</option>
            </select>
          </div>

          <div className="SelectStudent-wallet-checkbox">
            <input type="checkbox" id="wallet" />
            <label htmlFor="wallet">Collect amount from student wallet</label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GenerateInvoice;
